import { render, staticRenderFns } from "./bibleStudy.vue?vue&type=template&id=a67c882a&scoped=true&"
import script from "./bibleStudy.vue?vue&type=script&lang=js&"
export * from "./bibleStudy.vue?vue&type=script&lang=js&"
import style0 from "./bibleStudy.vue?vue&type=style&index=0&id=a67c882a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a67c882a",
  null
  
)

export default component.exports